import { _ as _defineProperty } from './helpers-d639255d.js';
import { n as normalizeComponent, B as BaseComponentMixin } from './plugins-4295ce0e.js';

var script = {
  name: 'OFieldBody',
  inject: {
    $field: {
      name: '$field',
      default: false
    }
  },
  computed: {
    parent: function parent() {
      return this.$field;
    }
  },
  render: function render(createElement) {
    var _this = this;

    var first = true;
    return createElement('div', {
      attrs: {
        'class': this.parent.contentHorizontalClasses
      }
    }, this.$slots.default.map(function (element) {
      // skip returns and comments
      if (!element.tag) {
        return element;
      }

      var message;

      if (first) {
        message = _this.parent.newMessage;
        first = false;
      }

      return createElement(_this.parent.rootClass, {
        attrs: {
          variant: _this.parent.newVariant,
          message: message
        }
      }, [element]);
    }));
  }
};

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

/**
 * Fields are used to add functionality to controls and to attach/group components and elements together
 * @displayName Field
 * @example ./examples/Field.md
 * @style _field.scss 
 */

var script$1 = {
  name: 'OField',
  components: _defineProperty({}, __vue_component__.name, __vue_component__),
  mixins: [BaseComponentMixin],
  provide: function provide() {
    return {
      $field: this
    };
  },
  props: {
    /**
     * 	Color of the field and help message, also adds a matching icon, optional. Used by Input, Select and Autocomplete
     *  @values primary, info, success, warning, danger, and any other custom color
     */
    variant: [String, Object],

    /**
     * Field label
     */
    label: String,

    /**
     * Same as native for set on the label
     */
    labelFor: String,

    /**
     * Help message text
     */
    message: String,

    /**
     * Direct child components/elements of Field will be grouped horizontally (see which ones at the top of the page)
     */
    grouped: Boolean,

    /**
     * Allow controls to fill up multiple lines, making it responsive
     */
    groupMultiline: Boolean,
    expanded: Boolean,

    /**
     * Group label and control on the same line for horizontal forms
     */
    horizontal: Boolean,

    /**
     * Field automatically attach controls together
     */
    addons: {
      type: Boolean,
      default: true
    },
    rootClass: String,
    horizontalClass: String,
    expandedClass: String,
    groupMultilineClass: String,
    labelClass: String,
    labelHorizontalClass: String,
    contentHorizontalClass: String,
    messageClass: String,
    variantClass: String
  },
  data: function data() {
    return {
      newVariant: this.variant,
      newMessage: this.message
    };
  },
  computed: {
    messageClasses: function messageClasses() {
      return [this.computedClass('field', 'messageClass', 'o-field-message'), _defineProperty({}, "".concat(this.computedClass('field', 'variantClass', 'o-color-')).concat(this.newVariant), this.newVariant)];
    },
    labelClasses: function labelClasses() {
      return [this.computedClass('field', 'labelClass', 'o-field-label')];
    },
    labelHorizontalClasses: function labelHorizontalClasses() {
      return [this.computedClass('field', 'labelHorizontalClass', 'o-field-horizontal-label')];
    },
    contentHorizontalClasses: function contentHorizontalClasses() {
      return [this.computedClass('field', 'contentHorizontalClass', 'o-field-horizontal-content')];
    },
    hasLabel: function hasLabel() {
      return this.label || this.$slots.label;
    },
    hasMessage: function hasMessage() {
      return this.newMessage || this.$slots.message;
    }
  },
  watch: {
    /**
    * Set internal variant when prop change.
    */
    variant: function variant(value) {
      this.newVariant = value;
    },

    /**
    * Set internal message when prop change.
    */
    message: function message(value) {
      this.newMessage = value;
    }
  },
  methods: {
    rootClasses: function rootClasses() {
      return [this.computedClass('field', 'rootClass', 'o-field'), _defineProperty({}, this.computedClass('field', 'groupMultilineClass', 'o-field-grouped-multiline'), this.groupMultiline), this.fieldType()];
    },

    /**
    * Field has addons if there are more than one slot
    * (element / component) in the Field.
    * Or is grouped when prop is set.
    * Is a method to be called when component re-render.
    */
    fieldType: function fieldType() {
      if (this.grouped) return 'o-field-grouped';
      var renderedNode = 0;

      if (this.$slots.default) {
        renderedNode = this.$slots.default.reduce(function (i, node) {
          return node.tag ? i + 1 : i;
        }, 0);
      }

      if (renderedNode > 1 && this.addons && !this.horizontal) {
        return 'o-field-addons';
      }

      return null;
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: _vm.rootClasses() },
    [
      _vm.horizontal
        ? _c("div", { class: _vm.labelHorizontalClasses }, [
            _vm.hasLabel
              ? _c(
                  "label",
                  { class: _vm.labelClasses, attrs: { for: _vm.labelFor } },
                  [
                    _vm.$slots.label
                      ? _vm._t("label")
                      : [_vm._v(_vm._s(_vm.label))]
                  ],
                  2
                )
              : _vm._e()
          ])
        : [
            _vm.hasLabel
              ? _c(
                  "label",
                  { class: _vm.labelClasses, attrs: { for: _vm.labelFor } },
                  [
                    _vm.$slots.label
                      ? _vm._t("label")
                      : [_vm._v(_vm._s(_vm.label))]
                  ],
                  2
                )
              : _vm._e()
          ],
      _vm._v(" "),
      _vm.horizontal
        ? _c("o-field-body", [_vm._t("default")], 2)
        : [_vm._t("default")],
      _vm._v(" "),
      _vm.hasMessage && !_vm.horizontal
        ? _c(
            "p",
            { class: _vm.messageClasses },
            [
              _vm.$slots.message
                ? _vm._t("message")
                : [_vm._v(_vm._s(_vm.message))]
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__$1 as _ };
